// extracted by mini-css-extract-plugin
export default {"header":"TabsBody_header__VKqE3","list":"TabsBody_list__M+dpC","item":"TabsBody_item__fPakM"};